module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/26add8d06fefebf31d5525168e6e51f4.png";